import { render, staticRenderFns } from "./ResellerReferralTile.vue?vue&type=template&id=427a35b1&scoped=true&"
import script from "./ResellerReferralTile.vue?vue&type=script&lang=js&"
export * from "./ResellerReferralTile.vue?vue&type=script&lang=js&"
import style0 from "./ResellerReferralTile.vue?vue&type=style&index=0&id=427a35b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427a35b1",
  null
  
)

export default component.exports